import { render, staticRenderFns } from "./TplListBasic.vue?vue&type=template&id=e4f7f9ba&scoped=true"
import script from "./TplListBasic.vue?vue&type=script&lang=js"
export * from "./TplListBasic.vue?vue&type=script&lang=js"
import style0 from "./TplListBasic.vue?vue&type=style&index=0&id=e4f7f9ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f7f9ba",
  null
  
)

export default component.exports